import { Slider as MuiSlider, SliderProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const StyledSlider = styled(MuiSlider)(({ theme }) => ({
  display: "block",
  color: theme.palette.secondary[2],
  paddingTop: theme.spacing(6),
  paddingBottom: 0,
  maxWidth: "calc(100% - 16px)",
  fontSize: "13px",
  position: "relative",
  zIndex: 1,

  "&.Mui-disabled": {
    opacity: 0.3,
  },

  "& .MuiSlider-thumb": {
    color: theme.palette.secondary[2],
    height: "20px",
    width: "20px",
  },

  "& .MuiSlider-thumb:hover": {
    color: theme.palette.secondary[1],
    boxShadow: "none",
  },

  "& .MuiSlider-track": {
    backgroundColor: theme.palette.secondary[3],
    border: "none",
    height: "16px",
  },

  "& .MuiSlider-rail": {
    opacity: 1,
    height: "16px",
    backgroundColor: theme.palette.secondary[4],
    boxShadow:
      "0px 0.5px 0px 0px rgba(226, 186, 248, 0.08) inset, 0px 0px 0.5px 0px rgba(226, 186, 248, 0.30) inset",
  },

  "& .MuiSlider-mark": {
    display: "hidden !important",
    opacity: 0.25,
    height: "12px",
    width: "1px",
  },

  "& .MuiSlider-thumb:before": {
    boxShadow: "none !important",
  },

  '& .MuiSlider-mark[data-index="0"], .MuiSlider-mark[style*="left: 0%"], .MuiSlider-mark[style*="left: 100%"]':
    {
      visibility: "hidden",
    },
}));

export const Slider = React.forwardRef<
  HTMLSpanElement | HTMLDivElement,
  SliderProps
>((props: SliderProps, ref) => {
  return <StyledSlider {...props} ref={ref} />;
});
